<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-04 13:08:18
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-16 11:01:34
 * @Description: 基础信息
-->
<template>
  <el-row>
    <el-col class="row" :span="24">
      <span class="label">{{$t('product.requisitionNo')}}</span>
      <Copyable :text="dataForm.demandCode" />
    </el-col>
    <el-col class="row" :span="24">
      <span class="label">{{$t('account.companyName')}}</span>{{ dataForm.companyName || '-' }}
    </el-col>
    <el-col class="row" :span="12">
      <span class="label">{{$t('common.principal')}}</span
      >{{ dataForm.customerLeaderName || '-' }}
    </el-col>
    <el-col class="row" :span="12">
      <span class="label">{{$t('stockNeed.phone')}}</span>
      <Copyable :text="dataForm.customerLeaderMobile" />
    </el-col>
    <el-col class="row" :span="24">
      <span class="label">{{$t('product.estimatedTime')}}</span
      >{{ dataForm.wishEndDate | formateDate }}
    </el-col>
    <el-col class="row" :span="24">
      <span class="label">{{$t('stockNeed.shippingAddress')}}</span>{{ dataForm.province
      }}{{ dataForm.city }}{{ dataForm.area }}{{ dataForm.address }}
    </el-col>
    <el-col class="row" :span="24">
      <span class="label">{{$t('stockNeed.spareNeeAgreement')}}</span>
      <OssFiles :ossFiles="dataForm.ossFile || []" />
    </el-col>
    <el-col class="row" :span="24">
      <span class="label">{{$t('common.comment')}}</span>{{ dataForm.remarks || '-' }}
    </el-col>
  </el-row>
</template>

<script>
import OssFiles from '@/components/ossFiles/index.vue'
import Copyable from '@/components/copyable/index.vue'
import { formateDate } from '@/utils/formateDate'
export default {
  filters: {
    formateDate (val) {
      return formateDate('yyyy-MM-dd', val)
    }
  },
  props: {
    dataForm: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    OssFiles,
    Copyable
  }
}
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  align-items: center;
}
.label {
  width: 140px;
  padding: 0 12px 0 0;
  color: #606266;
  font-size: 14px;
  line-height: 40px;
  text-align: right;

  &::after {
    content: '：';
  }
}
</style>
